export const AW_ENTITLEMENTS_API_URL = process.env?.AWAPI_AWENTITLEMENTS_URL || '/awentitlements';
export const AW_ENTITLEMENTS_API_URL_AGRAPH =
  process.env?.AWAPI_AWENTITLEMENTS_URL_AGRAPH || '/api/wealth/shared-service/users';
